import { useMemo } from 'react'
import { useCommonCMSConfig, useSwapCurrencies, useSwapFeatures } from '~api'
import { processSwap } from '~utils/data/processSwap'

export const useIsSwapDisabled = (currencyCode?: string) => {
    const { showSwapPage } = useCommonCMSConfig().data?.features ?? {}

    const { data: swapCurrencies, isLoading: isSwapCurrenciesLoading } = useSwapCurrencies()
    const { data: swapFeatures, isLoading: isFeaturesLoading } = useSwapFeatures()

    const availableSwapCurrencies = useMemo(
        () => processSwap(swapCurrencies, swapFeatures),
        [swapFeatures, swapCurrencies]
    )

    const isLoading = isSwapCurrenciesLoading || isFeaturesLoading

    if (isLoading || !showSwapPage) {
        return { isLoading, isDisabled: true }
    }

    const isCoinSwapDisabled = (code: string) => {
        const isFixedAvailable = availableSwapCurrencies.fixed.has(code)
        const isMarketAvailable = availableSwapCurrencies.market.has(code)
        const isEnabled = isFixedAvailable || isMarketAvailable
        return !isEnabled
    }

    const isDisabled = currencyCode
        ? isCoinSwapDisabled(currencyCode)
        : !availableSwapCurrencies.fixed.size && !availableSwapCurrencies.market.size

    return { isLoading, isDisabled }
}
